<template>
    <div class="buy-now-gift-complete">

        <!-- User -->
        <template v-if="isUserSignedIn">
            <transition name="fade">
                <div class="credit-img-wrapper">
                    <img v-show="imgLoaded" :src="require('home/buy-now/crema-cash-1.png')" class="credit-img" alt="Crema Cash" v-on:load="imgLoaded = true">
                </div>
            </transition>

            <h3>Your generosity moved us!</h3>

            <p class="padded">We will gift you $1 in site credit every time you gift a friend a bag of coffee. You'll receive your reward after their coffee ships.</p>

            <button class="btn-green-lg gift-complete-btn" @click="$emit('close')">
                Gift More Coffee
            </button>
        </template>

        <!-- Non user -->
        <template v-else>
            <transition name="fade">
                <div class="credit-img-wrapper">
                    <img v-show="imgLoaded" :src="require('home/buy-now/crema-cash-5.png')" class="credit-img" alt="Crema Cash" v-on:load="imgLoaded = true">
                </div>
            </transition>

            <h3>Take our coffee quiz and get 1/2 off your first order!</h3>

            <button class="btn-blue-lg gift-complete-btn" @click="navigateToOnboarding()">
                Met Your Match
            </button>
            <button class="btn-green-transparent-lg gift-complete-btn" @click="$emit('close')">
                Gift Another Coffee
            </button>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
          isUserSignedIn: Boolean
        },
        data: function() {
            return {
                imgLoaded: false
            }
        },
        methods: {
            navigateToOnboarding() {
                window.location.replace('/onboarding')
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/_variables_home.scss";
    @import "../../../styles/common_home.scss";

    .buy-now-gift-complete {
        text-align: center;
        padding-bottom: 2rem;
        h3 {
            margin: 0 0 1rem 0;
        }
    }
    .credit-img-wrapper {
        min-height: 240px;
        text-align: left;
        .credit-img {
            width: 88%;
            height: 88%;
            margin: -12px 0;
        }
    }
    .gift-complete-btn {
        margin-top: 2rem;
    }
</style>
